import { createContext, useContext } from 'react';
import NewsletterStore from '@features/footer/components/FooterNewsletter/mobx/stores/NewsletterStore';
let currentStore: NewsletterStore;
const initializeStore = () => {
  const newStore = currentStore ?? new NewsletterStore();
  if (!currentStore) currentStore = newStore;
  return newStore;
};
const NewsletterStoreContext = createContext<NewsletterStore>(initializeStore());
const useNewsletterStore = () => useContext(NewsletterStoreContext);
export { NewsletterStore, useNewsletterStore };